.strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.tile {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px 20px;
  border: var(--b);
  border-radius: var(--r-lg);
  background: var(--white);
  min-height: 110px;
  justify-content: space-between;
}

.eyebrow {
  font-family: var(--sans);
  font-weight: 900;
  font-size: 10.5px;
  letter-spacing: 1.6px;
  color: var(--mute);
  text-transform: uppercase;
}

.value {
  font-family: var(--sans);
  font-weight: 900;
  font-size: 38px;
  line-height: 1;
  letter-spacing: -1.5px;
  color: var(--ink);
}

.sub {
  font-family: var(--mono);
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 1.4px;
  color: var(--mute);
  text-transform: uppercase;
}

/* Variants */
.v_default { background: var(--white); }

.v_green {
  background: var(--green);
  color: var(--white);
}
.v_green .eyebrow,
.v_green .sub { color: rgba(255, 255, 255, 0.85); }
.v_green .value { color: var(--white); }

.v_orange {
  background: var(--orange);
}
.v_orange .eyebrow,
.v_orange .sub { color: var(--ink); }
